module.exports = __webpack_public_path__ + "img/code2_bkg.fc4abe64.png";